import React from 'react';
import {TourShotsPageQuery} from '../__generated__/TourShotsPageQuery.graphql';
import RelayRenderer from '../RelayRenderer';
import graphql from 'babel-plugin-relay/macro';
import {TruvuMenu} from '../components/TruvuMenu';
import {TruvuToursContainer} from '../components/containers/TruvuToursContainer';
import {useParams, useHistory} from 'react-router-dom';
import {TourShotsGrid} from '../modules/tourLanding/components/TourShotsGrid';
import {Button} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const query = graphql`
  query TourShotsPageQuery($tourID: ID!) {
    tour: node(id: $tourID) {
      ... on Tour {
        id
        title
        thumbnailURL
        ...TourShotsGrid_tour
      }
    }
    me {
      user {
        ...TruvuToursContainer_user
      }
    }
  }
`;

export function TourShotsPage() {
  const {tourId} = useParams<{tourId: string}>();
  const history = useHistory();

  return (
    <RelayRenderer<TourShotsPageQuery>
      query={query}
      variables={{tourID: tourId}}
    >
      {(data) => {
        console.log('TourShotsPage data:', data);
        console.log('Tour ID:', tourId);
        const tour = data.tour;
        if (!tour) {
          return <div>Tour not found - ID: {tourId}</div>;
        }

        return (
          <TruvuToursContainer userRef={data.me?.user}>
            <TruvuMenu
              title={`${tour.title} - Professional Shots`}
              action={
                <Button
                  startIcon={<ArrowBackIcon />}
                  onClick={() => history.push('/')}
                  variant="outlined"
                >
                  Back to Tours
                </Button>
              }
              sticky
            />
            <TourShotsGrid tourRef={tour} />
          </TruvuToursContainer>
        );
      }}
    </RelayRenderer>
  );
}
